import { Autocomplete, Box, FormControl, InputLabel, MenuItem, OutlinedInput, Select, Table } from '@mui/material'
import React, { useState } from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import ActionsBar from '../../../components/ActionsBar';
import { FilterAlt } from '@mui/icons-material'
import TextField from '@mui/material/TextField/TextField';
import Paper from '@mui/material/Paper'
import TableBody from '@mui/material/TableBody';
import TableCell, {tableCellClasses} from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles'
import CampaignItem from './components/CampaignItem';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

const Screen = () => {

    const onAddLead = () => {

    }

    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', width: '100%' }}>
            <ActionsBar title='Danh sách chiến dịch' subTitle='Tìm thấy: 1000 Lead' addButtonTitle='Thêm chiến dịch' onAddPress={onAddLead} />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginLeft: '24px', marginRight: '24px' }}>
                <Box sx={{ display: 'flex' }}>
                    <Box style={{ color: 'blue', display: 'flex', height: '36px', alignItems: 'center', justifyContent: 'center', width: '100px', marginRight: '16px', border: '1px solid #0000ff', borderRadius: '4px' }}>
                        <FilterAlt fontSize='13px' color='blue' />
                        <span style={{ color: 'blue', fontSize: '12px' }}>Bộ lọc</span>
                    </Box>
                    <TextField size='small' style={{ height: '32px', width: '320px' }} placeholder="Tên nhân viên, Email, số điện thoại" />
                </Box>
                <Box sx={{ display: 'flex' }}>
                    <FormControl style={{ width: '180px' }}>
                        <InputLabel id="demo-simple-select-label" style={{ fontSize: '12px', color: 'black' }}>Lọc theo người thực hiện</InputLabel>
                        <Select
                        >
                            <MenuItem value={10}>Tổng quản lý</MenuItem>
                            <MenuItem value={20}>Telesale</MenuItem>
                            <MenuItem value={30}>Sale</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Box>
            <div style={{ display: "flex", width: '100%', overflowY: 'scroll', marginTop: '24px' }}>
                <TableContainer component={Paper} style={{marginLeft: '24px', marginRight: '24px'}}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Tên chiến dịch</StyledTableCell>
                                <StyledTableCell align="right">Thời gian bắt đầu</StyledTableCell>
                                <StyledTableCell align="right">Thời gian kết thúc</StyledTableCell>
                                <StyledTableCell align="right">Người thực hiện</StyledTableCell>
                                <StyledTableCell align="right">Kênh truyền thông</StyledTableCell>
                                <StyledTableCell align="right">Chi tiết</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((row) => (
                                <CampaignItem row={row}/>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    )
}

export default Screen